<template>
  <div class="flex flex-col">
    <div class="grid grid-cols">
      <div class="card px-[15%] rounded-[5px] mb-4">
        <p class="text-[21px] font-semibold mb-[20px]">Campaign Information</p>
        <div class="flex gap-6">
          <div class="flex flex-col w-full">
            <input
              class="block pl-4 bg-inputbg rounded-[5px] h-14 w-full py-2 text-black focus:outline-none focus:bg-gray-200"
              :class="[empty ? 'border-2 border-red-500 ' : '']"
              type="text"
              placeholder="Campaign Name"
              v-model="stepOn.campaignTitle"
              required
              @blur="validateEmail"
            />
            <p v-if="empty" class="text-red-400 text-[14px] pt-1">
              This field is required
            </p>
          </div>
          <div class="flex flex-col w-full">
            <input
              class="block pl-4 bg-inputbg rounded-[5px] h-14 w-full py-2 text-black focus:outline-none focus:bg-gray-200"
              :class="[_empty ? 'border-2 border-red-500 ' : '']"
              id="name"
              type="text"
              placeholder="Company Name"
              v-model="stepOn.companyName"
            />
            <p v-if="_empty" class="text-red-400 text-[14px] pt-1">
              This field is required
            </p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card px-[15%] rounded-[5px]"
      :class="[eempty ? 'border-2 border-red-400 ' : '']"
    >
      <p class="text-[21px] font-semibold mb-[20px]">
        What is your desired outcome from this campaign?
      </p>
      <div class="grid grid-cols-2 gap-6">
        <button
          class="card shadow-md text-left rounded-[5px] w-[100%] text-[18px] font-semibold"
          :class="[
            step_one.advertisingGoal == 'Awareness'
              ? 'bg-primary text-white'
              : '',
          ]"
          @click="selectedGaolButton($event)"
          value="Awareness"
          type="button"
        >
          Awareness <br />
          <span class="text-[14px] font-normal h-0"
            >Reach millions of people on the streets every day</span
          >
        </button>
        <button
          class="card shadow-md text-left rounded-[5px] w-[100%] py-7 text-[18px] font-semibold"
          :class="[
            step_one.advertisingGoal == 'Conversions'
              ? 'bg-primary text-white'
              : '',
          ]"
          @click="selectedGaolButton($event)"
          value="Conversions"
          type="button"
        >
          Conversions <br />
          <span class="text-[14px] font-normal h-0"
            >Track your conversions in real-time</span
          >
        </button>
        <!-- <button
                    class="card shadow-md text-left rounded-[5px] w-[100%] py-7 text-[18px] font-medium capitalize"
                    :class="[
                        stepOn.advertisingGoal == 'Special event awareness'
                            ? 'bg-primary text-white'
                            : '',
                    ]"
                    @click="selectedGaolButton($event)"
                    value="Special event awareness"
                    type="button"
                >
                    Special event awareness

                    <p class="text-[14px] font-normal">Announce to your next event</p>
                </button>
                <button
                    class="card shadow-md text-left rounded-[5px] w-[100%] py-7 text-[18px] font-medium capitalize"
                    :class="[
                        stepOn.advertisingGoal == 'Product conversions' ? 'bg-primary text-white' : '',
                    ]"
                    @click="selectedGaolButton($event)"
                    value="Product conversions"
                    type="button"
                >
                    Product conversions
                    <p class="text-[14px] font-normal">Use a promo code to get discount</p>
                </button>
                <button
                    class="card shadow-md text-left rounded-[5px] w-[100%] py-7 text-[18px] font-medium capitalize"
                    :class="[
                        stepOn.advertisingGoal == 'Client acquisitions' ? 'bg-primary text-white' : '',
                    ]"
                    @click="selectedGaolButton($event)"
                    value="Client acquisitions"
                    type="button"
                >
                    Client acquisitions
                    <p class="text-[14px] font-normal">It aims to target new customers</p>
                </button> <button
                    class="card shadow-md text-left rounded-[5px] w-[100%] py-7 text-[18px] font-medium capitalize"
                    :class="[stepOn.selectedType == 'Advertiser' ? 'bg-primary text-white' : '']"
                    @click="webcamSendRequestButton($event)"
                    value="Advertiser"
                    type="button"
                >
                    I'm an advertiser
                    <p class="text-[14px] font-normal">
                        want to run ads on behalf of my own business.
                    </p>
                </button> -->
      </div>
      <p v-if="eempty" class="text-red-300 text-[14px] pt-1 text-center">
        This field is required
      </p>
    </div>
  </div>
  <div class="flex gap-2 flex-row-reverse mt-4">
    <button
      class="bg-primary p-2 px-[66px] rounded-[5px] text-white"
      @click="next()"
      v-if="$store.state.step < 4"
    >
      Next
    </button>
    <button
      class="bg-primary p-2 px-[66px] rounded-[5px] text-white"
      v-if="$store.state.step == 4"
    >
      Submit
    </button>
    <button
      class="bg-white p-2 px-[66px] rounded-[5px] text-primary border-2 border-primary"
      @click="back()"
      v-if="$store.state.step > 1"
    >
      Back
    </button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "../../store";

export default {
  data() {
    return {
      stepOn: {
        campaignTitle: null,
        companyName: null,
        advertisingGoal: null,
      },
      empty: false,
      _empty: false,
      eempty: false,
    };
  },
  computed: {
    ...mapGetters(["step_one"]),
  },
  methods: {
    validateEmail() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)) {
        this.msg["email"] = "Please enter a valid email address";
      } else {
        this.msg["email"] = "";
      }
    },
    // webcamSendRequestButton: function (e) {
    //     this.stepOn.selectedType = e.target.value;
    //     console.log(this.stepOn.selectedType);
    // },
    selectedGaolButton: function (e) {
      const newGoal = e.target.value;
      console.log(`Button Clicked - Setting goal to: ${newGoal}`); // Log the new goal
      this.stepOn.advertisingGoal = newGoal;

      console.log('Button Clicked - Committing to store:', JSON.stringify(this.stepOn)); // Log state before commit
      this.$store.commit("updataStepO", this.stepOn);
      console.log('Button Clicked - After commit, step_one from store:', JSON.stringify(this.step_one)); // Log store state after commit
    },
    next() {
      if (this.stepOn.campaignTitle == null) {
        this.empty = true;
        this.$store.state.step = this.$store.state.step;
        window.scrollTo(0, 0);
      } else if (this.stepOn.companyName == null) {
        this._empty = true;
        this.empty = false;
        this.$store.state.step = this.$store.state.step;
        window.scrollTo(0, 0);
      } else if (this.stepOn.advertisingGoal == null) {
        this.eempty = true;
        this._empty = false;
        this.empty = false;
        this.$store.state.step = this.$store.state.step;
        window.scrollTo(0, 0);
    //   } else if (this.$store.state.step < 4) {
    //     this.$store.commit("updataStepO", this.stepOn);
    //     this.$store.state.step = this.$store.state.step + 1;
    //     window.scrollTo(0, 0);
      } else {
        if (this.stepOn.advertisingGoal === "Awareness") {
          this.$store.commit("updataStepO", this.stepOn);
          this.$store.state.step = 3;
        } else {
          this.$store.commit("updataStepO", this.stepOn);
          this.$store.state.step = this.$store.state.step + 1;
        }
        window.scrollTo(0, 0);
      }
    },
    back() {
      if (this.$store.state.step > 1)
        this.$store.state.step = this.$store.state.step - 1;
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style></style>
